<template>
    <!-- Banner sempre visibile in cima quando la licenza non è attiva -->
    <v-banner class="licenza-banner" :color="bannerColore" :icon="bannerIcona" lines="one" sticky>
        <template #text>
            <span class="text-body-2 font-weight-medium">{{ bannerTesto }}</span>
        </template>
        <template #actions>
            <v-btn v-if="licenzaStato === 0 && emailConfirmata" size="small" variant="tonal" color="white"
                href="mailto:info@example.com">
                Contatta il supporto
            </v-btn>
            <v-btn v-if="!emailConfirmata" size="small" variant="tonal" color="white" :loading="reinvioLoading"
                @click="reinviaEmail">
                Reinvia email di conferma
            </v-btn>
        </template>
    </v-banner>
</template>

<script>
import { ref, computed } from 'vue'

export default {
    name: 'LicenzaBanner',

    props: {
        licenzaStato: {
            type: Number,
            default: 0   // 0=attesa, 1=attiva, -1=sospesa
        },
        emailConfirmata: {
            type: Boolean,
            default: false
        }
    },

    emits: ['reinvia-email'],

    setup(props, { emit }) {
        const reinvioLoading = ref(false)

        const bannerColore = computed(() => {
            if (props.licenzaStato === -1) return 'error'
            if (!props.emailConfirmata) return 'warning'
            return 'info'
        })

        const bannerIcona = computed(() => {
            if (props.licenzaStato === -1) return 'mdi-cancel'
            if (!props.emailConfirmata) return 'mdi-email-alert-outline'
            return 'mdi-clock-outline'
        })

        const bannerTesto = computed(() => {
            if (props.licenzaStato === -1)
                return 'Il tuo account è stato sospeso. Contatta il supporto per maggiori informazioni.'
            if (!props.emailConfirmata)
                return 'Conferma il tuo indirizzo email per completare la registrazione. Controlla la tua casella di posta.'
            return 'Account in attesa di attivazione. Il nostro team verificherà la tua richiesta a breve.'
        })

        const reinviaEmail = async () => {
            reinvioLoading.value = true
            emit('reinvia-email')
            setTimeout(() => { reinvioLoading.value = false }, 2000)
        }

        return { reinvioLoading, bannerColore, bannerIcona, bannerTesto, reinviaEmail }
    }
}
</script>

<style scoped>
.licenza-banner {
    z-index: 100;
}
</style>